export default __webpack_public_path__ + "static/media/stand.a8cf57e5.png";